function Similar() {
  this.list = [];
  this.lastItem = undefined;
  this.size = 0;
  return this;
}

Similar.prototype.get = function (key) {
  var index;

  if (this.lastItem && this.isEqual(this.lastItem.key, key)) {
    return this.lastItem.val;
  }

  index = this.indexOf(key);

  if (index >= 0) {
    this.lastItem = this.list[index];
    return this.list[index].val;
  }

  return undefined;
};

Similar.prototype.set = function (key, val) {
  var index;

  if (this.lastItem && this.isEqual(this.lastItem.key, key)) {
    this.lastItem.val = val;
    return this;
  }

  index = this.indexOf(key);

  if (index >= 0) {
    this.lastItem = this.list[index];
    this.list[index].val = val;
    return this;
  }

  this.lastItem = {
    key: key,
    val: val
  };
  this.list.push(this.lastItem);
  this.size++;
  return this;
};

Similar.prototype.delete = function (key) {
  var index;

  if (this.lastItem && this.isEqual(this.lastItem.key, key)) {
    this.lastItem = undefined;
  }

  index = this.indexOf(key);

  if (index >= 0) {
    this.size--;
    return this.list.splice(index, 1)[0];
  }

  return undefined;
}; // important that has() doesn't use get() in case an existing key has a falsy value, in which case has() would return false


Similar.prototype.has = function (key) {
  var index;

  if (this.lastItem && this.isEqual(this.lastItem.key, key)) {
    return true;
  }

  index = this.indexOf(key);

  if (index >= 0) {
    this.lastItem = this.list[index];
    return true;
  }

  return false;
};

Similar.prototype.forEach = function (callback, thisArg) {
  var i;

  for (i = 0; i < this.size; i++) {
    callback.call(thisArg || this, this.list[i].val, this.list[i].key, this);
  }
};

Similar.prototype.indexOf = function (key) {
  var i;

  for (i = 0; i < this.size; i++) {
    if (this.isEqual(this.list[i].key, key)) {
      return i;
    }
  }

  return -1;
}; // check if the numbers are equal, or whether they are both precisely NaN (isNaN returns true for all non-numbers)


Similar.prototype.isEqual = function (val1, val2) {
  return val1 === val2 || val1 !== val1 && val2 !== val2;
};

module.exports = Similar;